import { Input } from "antd";
import { useIntl } from "react-intl";

import "../../styles/search.css";

const { Search } = Input;

interface IProps {
  onSearch?:
    | ((
        value: string,
        event?:
          | React.ChangeEvent<HTMLInputElement>
          | React.MouseEvent<HTMLElement, MouseEvent>
          | React.KeyboardEvent<HTMLInputElement>
          | undefined
      ) => void)
    | undefined;
  searchText: string;
  onChangeValue:
    | React.ChangeEventHandler<HTMLInputElement>
    | React.Dispatch<React.SetStateAction<string>>;
}

const SearchComponent = (props: IProps) => {
  const { onSearch, searchText, onChangeValue } = props;
  const intl = useIntl();

  return (
    <Search
      autoFocus
      style={{ marginTop: 10, width: "60%" }}
      defaultValue={searchText}
      placeholder={intl.formatMessage({
        id: "dataset.container.input.search",
        defaultMessage: "Introduzca su texto aquí",
      })}
      onSearch={onSearch}
      value={searchText}
      onChange={(e: any) => onChangeValue(e.target.value)}
      enterButton
    />
  );
};
export default SearchComponent;
